"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/** When your routing table is too long, you can split it into small modules **/
var videoChannelRouter = {
  path: '/videoChannel',
  component: _layout.default,
  redirect: '/draftList/list',
  name: 'VideoChannel',
  meta: {
    title: '视频号',
    icon: 'clipboard'
  },
  children: [{
    path: 'productList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/videoChannel/videoList/index'));
      });
    },
    name: 'VideoChannelproductList',
    meta: {
      title: '过审商品',
      icon: '',
      noCache: true
    }
  }, {
    path: 'creatVideoChannel/:id?/:isDisabled?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/videoChannel/draftList/creatVideoChannel'));
      });
    },
    name: 'CreatVideoChannel',
    meta: {
      title: '添加视频号商品',
      icon: '',
      noCache: true,
      activeMenu: "/videoChannel/draftList"
    }
  }, {
    path: 'draftList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/videoChannel/draftList/index'));
      });
    },
    name: 'draftList',
    meta: {
      title: '草稿列表',
      icon: '',
      noCache: true
    }
  }, {
    path: 'apply',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/videoChannel/apply/index'));
      });
    },
    name: 'videoApply',
    meta: {
      title: '申请接入',
      icon: '',
      noCache: true
    }
  }]
};
var _default = exports.default = videoChannelRouter;